<template>
    <div>
        <label class="col-form-label pt-0">{{ label }}</label>
        <b-nav-item-dropdown
            :text="__(text, ['truncate'])"
            extra-toggle-classes="navbar-filter"
            extra-menu-classes="w-100 overflow-y-auto" left>
            <template v-if="config.searchable">
                <input type="text"
                       v-model="search"
                       placeholder="Search"
                       class="form-control"
                       style="width: 96%; margin-left: .325rem;" />
                <hr>
            </template>
            <b-dropdown-item
                v-on:click="onSelect(null)">-- All --</b-dropdown-item>
            <template v-if="initialized">
                <b-dropdown-item
                    v-for="value in filteredValues"
                    :key="value.id"
                    v-on:click="onSelect(value)"
                    >{{__(value.name, ['titleCase'])}}</b-dropdown-item>
            </template>
        </b-nav-item-dropdown>
    </div>
</template>
<script>

export default {
    data() {
        return {
            initialized: false,
            currentValue: this.value,
            search: null,
            values: [],
        }
    },

    props: ['value', 'changeFilter', 'config'],

    mounted() {
        if (this.config.values) {
            this.values = this.config.values;

            if (this.config.default) {
                this.currentValue = this.config.default;
                this.changeFilter(this.config.key, this.valueHandler(this.config.default));
            }

            this.initialized = true;
            return;
        }
        this.helpers('api').getData(this.config.endpoint)
            .then(response => {
                this.initialized = true;
                this.values = _.chain(response)
                    .get('data')
                    .map(value => {
                        return {
                            id: value.id,
                            name: value.fullname || value.name,
                        }
                    })
                    .sortBy('name')
                    .value();
            })
    },

    watch: {
        value(newValue) {
            this.currentValue = newValue;
        }
    },

    computed: {
        label() {
            const { name } = this.config;
            return `Filter by ${name}`;
        },
        text() {
            if (this.currentValue) {
                const label = this.__(this.currentValue.name, ['titleCase']);
                return label;
            }

            return '-- All --';
        },
        filteredValues() {
            if (!this.search) return this.values;
            return this.values.filter(value => {
                return String(value.name).toLowerCase()
                    .indexOf(String(this.search).toLowerCase()) >= 0;
            });
        },
        valueHandler() {
            return _.get(this.config, 'handle', _.property('id'));
        },
        default() {
            return _.get(this.config, 'default', null);
        },
    },

    methods: {
        onSelect(value) {
            this.currentValue = value;
            this.$emit('input', value);
            this.changeFilter(this.config.key, this.valueHandler(value));
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/CustomFilterComponent.vue